<div class="login-container">
  <div class="login">
    <!-- Updated falling papers container with increased number of colorful, smaller papers -->
    <div class="falling-papers">
      <!-- Existing papers -->
      <div
        class="paper"
        style="
          left: 5%;
          animation-duration: 4s;
          animation-delay: 0s;
          background-color: #ffd700;
        "
      ></div>
      <div
        class="paper"
        style="
          left: 15%;
          animation-duration: 3.8s;
          animation-delay: 0.5s;
          background-color: #ff69b4;
        "
      ></div>
      <div
        class="paper"
        style="
          left: 25%;
          animation-duration: 4.2s;
          animation-delay: 0.2s;
          background-color: #00bfff;
        "
      ></div>
      <div
        class="paper"
        style="
          left: 35%;
          animation-duration: 3.5s;
          animation-delay: 1s;
          background-color: #8a2be2;
        "
      ></div>
      <div
        class="paper"
        style="
          left: 45%;
          animation-duration: 4.5s;
          animation-delay: 0.8s;
          background-color: #ff4500;
        "
      ></div>
      <div
        class="paper"
        style="
          left: 55%;
          animation-duration: 3.7s;
          animation-delay: 0.3s;
          background-color: #adff2f;
        "
      ></div>
      <div
        class="paper"
        style="
          left: 65%;
          animation-duration: 4.1s;
          animation-delay: 0.6s;
          background-color: #1e90ff;
        "
      ></div>
      <div
        class="paper"
        style="
          left: 75%;
          animation-duration: 3.9s;
          animation-delay: 0.9s;
          background-color: #ff1493;
        "
      ></div>
      <div
        class="paper"
        style="
          left: 85%;
          animation-duration: 4.2s;
          animation-delay: 1.2s;
          background-color: #32cd32;
        "
      ></div>
      <div
        class="paper"
        style="
          left: 95%;
          animation-duration: 4s;
          animation-delay: 1s;
          background-color: #00ced1;
        "
      ></div>
      <!-- Additional papers -->
      <div
        class="paper"
        style="
          left: 12%;
          animation-duration: 3.6s;
          animation-delay: 0.3s;
          background-color: #ffb6c1;
        "
      ></div>
      <div
        class="paper"
        style="
          left: 28%;
          animation-duration: 4.3s;
          animation-delay: 0.7s;
          background-color: #98fb98;
        "
      ></div>
      <div
        class="paper"
        style="
          left: 42%;
          animation-duration: 3.9s;
          animation-delay: 0.4s;
          background-color: #87cefa;
        "
      ></div>
      <div
        class="paper"
        style="
          left: 68%;
          animation-duration: 4.4s;
          animation-delay: 0.5s;
          background-color: #ffa07a;
        "
      ></div>
      <div
        class="paper"
        style="
          left: 82%;
          animation-duration: 3.8s;
          animation-delay: 0.6s;
          background-color: #dda0dd;
        "
      ></div>
    </div>
    <div style="display: flex; flex-direction: column; align-items: center">
      <img src="assets/images/newLogo.png" />
      <h2 class="col-sm-12" style="margin-bottom: 24px">
        {{ "REFERRAL.THANKS_FOR_REGISTER" | translate }} 5dma.vip
      </h2>
    </div>

    <!--    <p style="color: white">{{ "REERRAL.IN" | translate }}</p>-->
    <form
      style="z-index: 11"
      class="login-form"
      [formGroup]="referralForm"
      (ngSubmit)="onSubmit()"
    >
      <div class="row" style="margin: 8px 0 16px 0">
        <div
          class="col-sm-12 start-sm"
          style="padding: 0; margin-top: -10px; text-align: center"
        >
          <span class="ref-text">{{
            "REFERRAL.HAVE_A_REFERRAL" | translate
          }}</span>
        </div>
      </div>
      <div class="flex-toggle-btns">
        <mat-button-toggle-group
          [hideSingleSelectionIndicator]="true"
          name="favoriteColor"
          aria-label="Favorite Color"
        >
          <ng-template ngFor let-referral [ngForOf]="referralTypes">
            <mat-button-toggle
              [ngClass]="{ selectedClass: selectedReferralType(referral.id) }"
              (click)="setReferralType(referral)"
              [value]="referral.id"
            >
              {{ referral.bundleCode | translate }}
            </mat-button-toggle>
          </ng-template>
        </mat-button-toggle-group>
      </div>
      <ng-template [ngIf]="referralId === 1">
        <mat-form-field appearance="outline" class="col-md-12">
          <mat-label>{{
            "REFERRAL.SALES_SPECIALIST_PHONE" | translate
          }}</mat-label>
          <input
            [required]="referralId === 1"
            matInput
            formControlName="accountManagerPhoneNumber"
            (keypress)="keyPress($event)"
          />
        </mat-form-field>
      </ng-template>
      <ng-template [ngIf]="referralId === 2">
        <mat-form-field appearance="outline" class="col-md-12">
          <mat-label>{{ "REFERRAL.CUST_PHONE" | translate }}</mat-label>
          <input
            [required]="referralId === 2"
            matInput
            formControlName="customerPhoneNumber"
            (keypress)="keyPress($event)"
          />
        </mat-form-field>
      </ng-template>
      <div style="width: 100%; margin-bottom: 10px">
        <button
          class="login-button"
          *ngIf="referralForm"
          mat-raised-button
          type="submit"
          color="primary"
          style="width: 100%"
        >
          <span>{{ "COMMON.SEND" | translate }}</span>
        </button>
      </div>
      <span
        class="mat-error error"
        style="text-align: center"
        *ngIf="referralForm.touched && referralForm.invalid"
        >{{ "LOGIN.REFERRAL_MESSAGE" | translate }}</span
      >
      <!-- Moved and centered skip-to-login link -->
      <div class="register-text" style="text-align: center; width: 100%">
        <p>{{ "REFERRAL.OR" | translate }}</p>
        <div style="padding: 0; text-align: center; width: 100%">
          <button
            [routerLink]="['../login']"
            style="
              font-size: 16px;
              text-decoration: underline;
              margin-bottom: 10px;
            "
            mat-button
            type="button"
            color="primary"
          >
            <span>{{ "REFERRAL.SKIP_TO_LOGIN" | translate }}</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
